import axios from "axios";
import * as Constants from "../Constants/index";

export const FEEDBACK_FORM_ENDPOINTS = {
  submit: `${Constants.baseUrl}distributor/feedback`,
};

export async function submitFeedbackForm(payload) {
  const requestBody = {
    mobile: payload.mobile,
    overallExperience: payload.overallExperience,
    eventOrganization: payload.eventOrganization,
    stayHospitality: payload.stayHospitality,
    plantVisitExperience: payload.plantVisitExperience,
    rndVisitExperience: payload.rndVisitExperience,
    presentationSession: payload.presentationSession,
    keyTakeaway: payload.keyTakeaway,
    areasOfImprovement: payload.areasOfImprovement,
    additionalComments: payload.additionalComments,
  };

  const response = await axios.post(FEEDBACK_FORM_ENDPOINTS.submit, requestBody, {
    headers: {
      appVersion: Constants.av,
      platform: Constants.pt,
      company: Constants.company,
      program: Constants.program,
      "Content-Type": "application/json",
    },
  });

  return {
    success: true,
    endpoint: FEEDBACK_FORM_ENDPOINTS.submit,
    message: response?.data?.msg || "Feedback submitted successfully.",
    data: response?.data,
  };
}
